import React from 'react';
import Landing from "../../landing/containers/LandingContainer";

import CruceContainer from './CruceContainer';

const CruceHOC = (props) => {
  return (
    <Landing history={props.history} hasFooter={false}>
      <CruceContainer />
    </Landing>
  )
}

export default CruceHOC;